import React, { useState } from 'react';
import styles from './AdminLogin.module.css';
import { useNavigate } from 'react-router-dom';
import { LoginAPI } from './AllApi';
import Footer from './Footer';
import Header from './Header';
import { toast } from 'react-toastify';

const AdminLogin = () => {
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
  
    const loginData = {
      userId: loginId,
      userPassword: password,
    };
  
    try {
      const response = await fetch(LoginAPI.login, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(loginData),
      });
  
      const result = await response.json(); // Extract response message
     // console.log('Server response:', result);
  
      if (response.ok && result.message === 'Login successful') {
        navigate('/dashboard');
      } else {
        toast.error(result.message || 'Login failed. Please check credentials.');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Something went wrong. Please try again.');
    }
  };  

  return (
    <>
    <Header/>
    <div className={styles.container}>
      <form className={styles.loginBox} onSubmit={handleLogin}>
        <h2 className={styles.title}>Admin Login</h2>
        <input
          type="text"
          placeholder="Login ID"
          className={styles.input}
          value={loginId}
          onChange={(e) => setLoginId(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          className={styles.input}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit" className={styles.button}>
          Login
        </button>
      </form>
    </div>
    <Footer/>
    </>
  );
};

export default AdminLogin;
